import { forwardRef } from "react";
import { Link as RouterLink } from "react-router-dom";
import { useLanguage } from "../LanguageContext";

// Link que traduce la ruta ES al idioma actual (/modulos -> /en/modules).
export const Link = forwardRef(function Link({ to, ...props }, ref) {
  const { lp } = useLanguage();
  return <RouterLink ref={ref} to={typeof to === "string" ? lp(to) : to} {...props} />;
});

export default Link;
